/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriverUpdateRecommendation: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetDriverUpdateRecommendationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetDriverUpdateRecommendation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDriverInstallHistory: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetDriverInstallHistoryParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetDriverInstallHistory',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriverInstallHistory: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetDriverInstallHistoryReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetDriverInstallHistory',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserDriverTypePreference: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetUserDriverTypePreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetUserDriverTypePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetUserDriverTypePreference: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetUserDriverTypePreferenceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetUserDriverTypePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUpdateStrategyPreference: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetUpdateStrategyPreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetUpdateStrategyPreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetUpdateStrategyPreference: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetUpdateStrategyPreferenceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetUpdateStrategyPreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAutomaticDriverDownloadEnabled: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetAutomaticDriverDownloadEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetAutomaticDriverDownloadEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAutomaticDriverDownloadEnabled: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetAutomaticDriverDownloadEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetAutomaticDriverDownloadEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartDriverUpdateCheck: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'StartDriverUpdateCheck',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterDriverUpdateCheckProgressNotifications: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.RegisterDriverUpdateCheckProgressNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'RegisterDriverUpdateCheckProgressNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGRDEditorPreviewMode: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetGRDEditorPreviewModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetGRDEditorPreviewMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriverUpdateNotificationEnabled: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetDriverUpdateNotificationEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetDriverUpdateNotificationEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDriverUpdateNotificationEnabled: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetDriverUpdateNotificationEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetDriverUpdateNotificationEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGPUInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GPUInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetGPUInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGenericInfo: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GenericInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetGenericInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRewardsNotificationPreference: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetRewardsNotificationPreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetRewardsNotificationPreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetRewardsNotificationPreference: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetRewardsNotificationPreferenceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetRewardsNotificationPreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLanguagePreference: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverupdaterecommendation.GetLanguagePreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetLanguagePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetLanguagePreference: BridgeCommands.Command<
    Types.Nvapp.Driverupdaterecommendation.SetLanguagePreferenceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetLanguagePreference',
    persistent: false
};

export const Driverupdaterecommendation = {
GetDriverUpdateRecommendation,
SetDriverInstallHistory,
GetDriverInstallHistory,
GetUserDriverTypePreference,
SetUserDriverTypePreference,
GetUpdateStrategyPreference,
SetUpdateStrategyPreference,
GetAutomaticDriverDownloadEnabled,
SetAutomaticDriverDownloadEnabled,
StartDriverUpdateCheck,
RegisterDriverUpdateCheckProgressNotifications,
GetGRDEditorPreviewMode,
GetDriverUpdateNotificationEnabled,
SetDriverUpdateNotificationEnabled,
GetGPUInfo,
GetGenericInfo,
GetRewardsNotificationPreference,
SetRewardsNotificationPreference,
GetLanguagePreference,
SetLanguagePreference
};
